export default __webpack_public_path__ + "eFeedbackImg2.png";